import { render, staticRenderFns } from "./Featured_tx_right.vue?vue&type=template&id=db6d157a&scoped=true&"
import script from "./Featured_tx_right.vue?vue&type=script&lang=js&"
export * from "./Featured_tx_right.vue?vue&type=script&lang=js&"
import style0 from "./Featured_tx_right.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Featured_tx_right.vue?vue&type=style&index=1&id=db6d157a&scoped=true&lang=css&"
import style2 from "./Featured_tx_right.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6d157a",
  null
  
)

component.options.__file = "Featured_tx_right.vue"
export default component.exports